/**
 * Select Component
 *
 * Labeled dropdown select field.
 *
 * @package PresszoneComments
 */

import { el } from '../utils/dom.js';

/**
 * Render a select dropdown.
 *
 * @param {string} key - State key
 * @param {string} label - Field label
 * @param {string} help - Tooltip help text
 * @param {Array} options - Array of { value, label, default? } objects
 * @param {Object} state - State object containing value
 * @param {Function} onUpdate - Callback when value changes
 * @param {Function} onChange - Additional onChange callback
 * @param {Object} props - Additional properties (styling, padding, attrs, etc.)
 */
export function Select(key, label, help, options, state, onUpdate, onChange = null, props = {}) {
    const { styling, padding, showBorders = true, style, ...inputProps } = props;

    const classes = ['presszone-multilingual-select--settings'];
    if (styling) classes.push(`presszone-multilingual-select--styling-${styling}`);
    if (padding) classes.push(`presszone-multilingual-select--padding-${padding}`);
    if (showBorders === false) classes.push('presszone-multilingual-select--no-borders');

    return el('div', { class: 'presszone-multilingual-form-group', style: style },
        el('label', { class: 'presszone-multilingual-label--settings', for: key },
            label,
            help ? el('span', { class: 'presszone-multilingual-tooltip', title: help }, 'i') : null
        ),
        el('select', {
            id: key,
            class: classes.join(' '),
            onchange: (e) => {
                state[key] = e.target.value;
                if (onUpdate) onUpdate(key, e.target.value);
                if (onChange) onChange(e.target.value);
            },
            ...inputProps
        }, ...options.map(opt =>
            el('option', { value: opt.value, selected: state[key] === opt.value || (!state[key] && opt.default) }, opt.label)
        ))
    );
}

export default Select;
